<template>
  <div>
    <div class="elevation-1">
      <v-toolbar flat color="white">
        <v-toolbar-title> SUBCATEGORIA </v-toolbar-title>
        <v-divider class="mx-4" inset vertical></v-divider>
        <v-toolbar-title v-if="subcategory.id"
          >{{ subcategory.id }} -
          {{ subcategory.name.toUpperCase() }}</v-toolbar-title
        >
        <v-spacer></v-spacer>
        <v-btn outlined color="grey darken-3" @click="goToBackList()">
          <v-icon left>mdi-chevron-left</v-icon> Voltar
        </v-btn>
        <v-progress-linear
          :active="loading"
          :indeterminate="loading"
          absolute
          bottom
          color="deep-purple accent-4"
        ></v-progress-linear>
      </v-toolbar>
      <v-form ref="form" v-model="valid" :lazy-validation="lazy">
        <v-container fluid>
          <v-row>
            <v-col cols="12" xs="12" md="4">
              <v-text-field
                v-model="subcategory.name"
                class="text-field-uppercase"
                label="Nome"
                dense
                outlined
                required
                :rules="[rules.required]"
              ></v-text-field>
            </v-col>
            <v-col cols="12" xs="12" md="8"> </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" xs="12" md="4">
              <v-select
                :items="categories"
                v-model="subcategory.category_id"
                label="Categoria"
                item-text="name"
                item-value="id"
                required
                dense
                outlined
                :rules="[rules.required]"
              ></v-select>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12">
              <v-switch
                v-model="subcategory.status"
                :label="`Status: ${getLabelStatus(subcategory.status)}`"
              ></v-switch>
            </v-col>
          </v-row>
          <v-row>
            <v-col>
              <v-btn color="blue darken-3" dark class="mt-5" @click="validate">
                <v-icon left>mdi-send</v-icon> Salvar
              </v-btn>
            </v-col>
          </v-row>
        </v-container>
      </v-form>
    </div>
  </div>
</template>

<script>
import * as API from "@/api/requests/SubcategoryRequest";
import * as CategoryAPI from "@/api/requests/CategoryRequest";

export default {
  components: {},
  data: () => ({
    loading: false,
    subcategory: {
      id: "",
      name: "",
      status: 1,
    },
    categories: [],
    valid: true,
    lazy: false,
    rules: {
      required: (value) => !!value || "Campo Obrigatorio",
    },
  }),
  computed: {},
  created() {
    this.initialize();
  },
  methods: {
    async initialize() {
      await this.getCategories();
      if (this.$route.params.id) {
        this.getSubcategory(this.$route.params.id);
      }
    },
    async getSubcategory(id) {
      // this.showLoading();
      this.loading = true;
      try {
        this.subcategory = await API.getById(id);
      } catch (error) {
        this.subcategory = {};
        console.log(error);
        //this.showAlert({ message: error.message, type: "error" });
      } finally {
        this.loading = false;
        // this.hideLoading();
      }
    },
    async getCategories() {
      this.loading = true;
      try {
        let data = await CategoryAPI.getAll();
        this.categories = data.sort((a, b) => (a.name > b.name ? 1 : -1));
      } catch (error) {
        this.categories = [];
        console.log(error);
      } finally {
        this.loading = false;
      }
    },
    goToBackList() {
      this.$router.push({ name: "Subcategory" });
    },
    validate() {
      if (this.$refs.form.validate()) {
        this.subcategory.name = this.subcategory.name.toUpperCase();
        this.subcategory.status = this.subcategory.status ? 1 : 0;
        let data = { ...this.subcategory };
        if (this.subcategory.id === "") {
          this.post(data);
        } else {
          this.update(this.subcategory.id, data);
        }
      }
    },
    async post(data) {
      // this.showLoading();
      this.loading = true;
      try {
        await API.post(data);
        this.goToBackList();
      } catch (error) {
        console.log(error);
        // this.showAlert({ message: error.message, type: "error" });
      } finally {
        this.loading = false;
        // this.hideLoading();
      }
    },
    async update(id, data) {
      this.loading = true;
      try {
        await API.update(id, data);
        this.goToBackList();
      } catch (error) {
        console.log(error);
        // this.showAlert({ message: error.message, type: "error" });
      } finally {
        this.loading = false;
        // this.hideLoading();
      }
    },
    getLabelStatus(status) {
      return status == 1 ? "Ativo" : "Desativado";
    },
  },
};
</script>
<style>
.text-field-uppercase input {
  text-transform: uppercase;
}
</style>
